import { PaymentCard } from '../data/payment-card.do';
import { ProductTypeToPayFor } from '../other/product-type-to-pay-for.enum';

export interface ICardPaymentOptions<Office extends string = string> {
  /**
   * The ID of items to pay for; tracking numbers in case of shipments.
   */
  items: string[];
  card: PaymentCard;
  product: ProductTypeToPayFor;
  salesOffice: Office;
}
